export const accessPermission = (access) => {
  let access_data = localStorage.getItem("access");
  let permission = localStorage.getItem("permission");

  permission = JSON.parse(permission);
  access_data = JSON.parse(access_data);
  permission = [...permission, ...access_data];

  let find = permission.includes(access);

  return find;
};
